import React from "react";
import { Row, Col, Tabs } from 'antd';
import { convertToTimestamp, getStartTimeBeforeXDays, getEndTimeAfterXDays } from "@/lib/dateTime";
import RollCallonfig from "@/config/rollCall";
import Interval from "./Interval";

const { getRollCallGroupInfo, getVacationAndMakeUpDay } = RollCallonfig;
const { TabPane } = Tabs;

interface state {
  rollCallGroupArray: any;
  specialDateArray: any;
}

class RollCall extends React.Component<{}, state> {
  state = {
    rollCallGroupArray: [],
    specialDateArray: [],
  };

  componentDidMount() {
    this.getRollCallGroupInfo();
    this.getVacationAndMakeUpDay();
  }

  getRollCallGroupInfo = () => {
    getRollCallGroupInfo().then((res: any) => {
      const rollCallGroupArray = res?.value ?? {};
      this.setState({ rollCallGroupArray });
    });
  }

  getVacationAndMakeUpDay = () => {
    const params = { startTime: convertToTimestamp(getStartTimeBeforeXDays(15)), endTime: convertToTimestamp(getEndTimeAfterXDays(15)) };

    getVacationAndMakeUpDay(params).then((res: any) => {
      const specialDateArray = res?.value ?? [];

      this.setState({ specialDateArray });
    });
  }

  renderIntervalTab = () => {
    const { rollCallGroupArray, specialDateArray } = this.state;

    return rollCallGroupArray.map((item: any, index: number) =>
      <TabPane key={index} tab={item}>
        <Interval
          selectedInterval={item}
          specialDateArray={specialDateArray}
        />
      </TabPane >
    );
  }

  render() {
    return (
      <Row>
        <Col span={24}>
          <Tabs type="card">
            {this.renderIntervalTab()}
          </Tabs>
        </Col>
      </Row>
    );
  }
}

export default RollCall;